import { Component, OnInit } from '@angular/core';
import { DataLoginModel } from '../../models/dataLoginModel';

@Component({
  selector: 'app-home-distribuidor',
  templateUrl: './home-distribuidor.component.html',
  styleUrls: ['./home-distribuidor.component.css']
})
export class HomeDistribuidorComponent implements OnInit {

  dataUsuario: DataLoginModel;

  constructor() { }

  ngOnInit() {
    this.dataUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
  }

}
